import {Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges} from '@angular/core';
import {DocumentDataModel} from '../../../../../models/document/document-data.model';
import {DocumentInFolderDataModel} from '../../../../../models/document/document-in-folder-data.model';
import { RightClickData } from 'src/app/models/ui/rightclickdata';

@Component({
  standalone: false,
  selector: 'app-io-view-detail',
  templateUrl: './io-view-detail.component.html',
  styleUrls: ['./io-view-detail.component.css']
})
export class IoViewDetailComponent implements OnInit, OnChanges {
  @Input() images: DocumentInFolderDataModel[] = [];
  @Input() showThumbnail: boolean = false;

  @Output() onRightClick: EventEmitter<RightClickData> = new EventEmitter<RightClickData>();
  @Output() onDblClick: EventEmitter<DocumentDataModel> = new EventEmitter<DocumentDataModel>();

  docs: DocumentDataModel[] = [];

  constructor() { }
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.images) {
      this.docs = this.images.map(p => p.dataDocument);
    }
  }

  onDataGridRightClick(event) {
    const mouseEvent: MouseEvent = event.event;
    mouseEvent.preventDefault();

    const selectedImage: DocumentDataModel = this.docs[event.rowIndex];
    this.onRightClick.emit({ event: mouseEvent, object: selectedImage, isTreeNode: false });
  }

  descriptionColumn_customizeText(cellInfo): string {
    const text: string = cellInfo.value;
    if (text.trim() === "")
      return "No Description";
    else
      return text;
  }

  categoriesColumn_customizeText(cellInfo): string {
    const dataDoc: any[] = cellInfo.value;

    if (dataDoc.length === 0) {
      return "No categories"
    }
    else if (dataDoc.length === 1) {
      return dataDoc.pop().enumDocumentTag.ItemDisplayValue;
    }
    else {
      const displayValues = dataDoc.map(o => o.enumDocumentTag.ItemDisplayValue);
      const last = displayValues.pop();
      return displayValues.join(', ') + ", " + last;
    }
  }
}
